import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { LogoMark } from '@/components/shared'
import { websiteContent } from '@/features/website/content'
import FooterSection from '@/features/website/components/FooterSection'

const { privacyPolicy } = websiteContent

function PrivacyPolicyPage() {
  useEffect(() => {
    // Some browsers don't support the scroll options object.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } catch {
      window.scrollTo(0, 0)
    }
  }, [])

  return (
    <div className="min-h-screen bg-white text-gray-dark">
      <header className="bg-brand-green">
        <div className="mx-auto flex w-full max-w-[1200px] items-center px-6 py-6 md:px-10">
          <Link to="/" aria-label="NXT Humans home" className="block">
            <LogoMark
              variant="dark"
              className="h-[32px] w-[180px] md:h-[40px] md:w-[220px]"
            />
          </Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-[960px] px-6 py-12 md:py-20">
        <h1 className="text-h1 font-archivo font-extralight text-black">
          {privacyPolicy.title}
        </h1>
        <p className="mt-4 text-body-md font-archivo font-light text-gray-dark">
          <span className="font-semibold text-black">Effective Date:</span>{' '}
          {privacyPolicy.effectiveDate}
        </p>

        <div className="mt-10 space-y-6">
          {privacyPolicy.introduction.map((paragraph) => (
            <p
              key={paragraph.slice(0, 32)}
              className="text-body-md font-archivo font-light text-gray-dark"
            >
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-12 space-y-10">
          {privacyPolicy.sections.map((section) => (
            <section key={section.id} className="space-y-4">
              <h2 className="text-h3 font-archivo font-light text-black">
                {section.heading}
              </h2>
              {section.body ? (
                <p className="text-body-md font-archivo font-light text-gray-dark">
                  {section.body}
                </p>
              ) : null}
              {section.bullets ? (
                <ul className="list-disc space-y-2 pl-6 text-body-md font-archivo font-light text-gray-dark">
                  {section.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              ) : null}
              {section.subSections ? (
                <div className="space-y-6">
                  {section.subSections.map((subSection) => (
                    <div key={subSection.id} className="space-y-3">
                      <h3 className="text-body-md font-archivo font-semibold text-black">
                        {subSection.heading}
                      </h3>
                      {subSection.body ? (
                        <p className="text-body-md font-archivo font-light text-gray-dark">
                          {subSection.body}
                        </p>
                      ) : null}
                      {subSection.bullets ? (
                        <ul className="list-disc space-y-2 pl-6 text-body-md font-archivo font-light text-gray-dark">
                          {subSection.bullets.map((bullet) => (
                            <li key={bullet.label}>
                              <span className="font-semibold text-black">
                                {bullet.label}:
                              </span>{' '}
                              {bullet.description}
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </div>
                  ))}
                </div>
              ) : null}
              {section.id === 'contact-us' ? (
                <p className="text-body-md font-archivo font-light text-gray-dark">
                  <span className="font-semibold text-black">NXT Humans</span>
                  <br />
                  <a
                    href={`mailto:${privacyPolicy.contactEmail}`}
                    className="text-brand-green underline"
                  >
                    {privacyPolicy.contactEmail}
                  </a>
                </p>
              ) : null}
            </section>
          ))}
        </div>
      </main>

      <FooterSection />
    </div>
  )
}

export default PrivacyPolicyPage
